import React from "react";
import "./CrumbAboutPageStyle.css";
import DonationPage from "./DonationPage";

function CrumbAboutPage() {
    return (
        <div className="crumb-about-root">
            <header className="crumb-about-hero">
                <h1 className="crumb-about-title">About The Crumb NFT Explorer</h1>
                <p className="crumb-about-subtitle">
                    Created so that digital art collectors can elegantly browse their NFT collection with all the details readily available.
                    The Crumb NFT Explorer is a focused viewer for Solana NFTs, built to make browsing your art collection easier to view,
                    explore, and debug — for collectors, artists, and devs. Created by The Simulacrum.
                </p>
            </header>

            <main className="crumb-about-grid">
                <section className="crumb-about-card">
                    <h2 className="crumb-about-card-title">What is The Crumb - NFT Wallet Explorer?</h2>
                    <p className="crumb-about-card-body">
                        The Crumb NFT Explorer is a Solana wallet viewer designed to show
                        regular NFTs, Core NFTs, and compressed NFTs together in one place.
                        It&apos;s built as a practical tool — part explorer, part lab — for
                        understanding what&apos;s actually sitting inside a wallet.

                        Many wallets filter out spam NFTs, which is useful, but it also filters out NFTs
                        that aren't spam and they don't always capture all your collectibles. The Crumb NFT Explorer
                        if for seeing all the tokens in your wallet and the associated data.
                    </p>



                </section>

                <section className="crumb-about-card">
                    <h2 className="crumb-about-card-title">Why We Built It</h2>
                    <p className="crumb-about-card-body">
                        Most explorers are optimized for trading. Crumb is optimized for clarity:
                        clean media previews, useful metadata, and filters that help you slice a
                        wallet by type, media, and name. It&apos;s especially helpful when working
                        with compressed NFTs and on-chain experiments.
                    </p>
                </section>

                <section className="crumb-about-card">
                    <h2 className="crumb-about-card-title">What You Can Do</h2>
                    <ul className="crumb-about-list">
                        <li>View standard, Core, and compressed NFTs in a single interface.</li>
                        <li>Filter tokens by media type: images, video, or audio.</li>
                        <li>Search by name to quickly find specific pieces.</li>
                        <li>Inspect collection, mint address, and metadata URIs.</li>
                        <li>Optionally burn tokens (for advanced users who know what they&apos;re doing).</li>
                        <li>The Burn Mechanism may not work for certain NFTs, like compressed NFTs or NFTs that have already been burned.</li>
                    </ul>
                </section>

                <section className="crumb-about-card">
                    <h2 className="crumb-about-card-title">Search Functions</h2>
                    <ul className="crumb-about-list">
                        <li>Search for wallet accounts with public key and Solana Name Service accounts, like .Sol domains.</li>
                        <li>Not all domains have been approved with this API with SNS, like .skr</li>
                        <li>Search for accounts with the .url using explorer.thesimulacrum.xyz/dashboard/public-key-or-domain</li>
                        <li>Lookup tokens by url explorer.thesimulacrum.xyz/token/mint-address</li>
                    </ul>
                </section>

                <section className="crumb-about-card">
                    <h2 className="crumb-about-card-title">For Devs & QA</h2>
                    <p className="crumb-about-card-body">
                        The explorer is also a dev tool. It&apos;s wired for testing different
                        wallet states, styles, and media formats — including manually unlocked
                        styles and accounts used for QA. If something looks broken or unexpected,
                        that&apos;s exactly the kind of feedback that helps improve it.
                    </p>
                    <p className="crumb-about-note">
                        If you notice glitches, missing media, or sorting issues, please grab a
                        screenshot and share it with the dev team.
                    </p>
                </section>
                <section className="crumb-about-card">
                    <h2 className="crumb-about-card-title">Style Shop</h2>
                    <p className="crumb-about-card-body">
                        Browse your collection in the style of your choice!

                        Use the Style Shop to purchase and unlock new styles for The Crumb NFT Wallet Explorer.
                        When you purchase a style you get an NFT as a record of pruchase / receipt, and may have more utility in the future.
                        It is the public key of the wallet that unlocks the styles, for now. In the future we may do both,
                        record the public key AND use the NFT to unlock styles.
                    </p>
                </section>

                <section className="crumb-about-card">
                    <h2 className="crumb-about-card-title">Audio NFT Player</h2>
                    <p className="crumb-about-card-body">
                        The Audio Player allows you to listen to your audio NFTs in a playlist.
                        Audio tokens are detected automatically from
                        on-chain metadata and rendered with native playback controls.
                    </p>
                    <p className="crumb-about-card-body">
                        This makes it easy to consume music, spoken word, sound art, and
                        experimental audio NFTs without leaving the NFT player or opening
                        external links.
                    </p>
                </section>


                <section className="crumb-about-card">
                    <h2 className="crumb-about-card-title">Video NFT Player</h2>
                    <p className="crumb-about-card-body">
                        The Video Player enables smooth, inline playback of your collection of
                        video NFTs  directly from The Crumb NFT Explorer. Videos are displayed alongside
                        preview images and metadata, in OG mode.
                    </p>
                    <p className="crumb-about-card-body">
                        This is great for enjoying ad-free video content that you collected.
                    </p>
                </section>


                <section className="crumb-about-card">
                    <h2 className="crumb-about-card-title">Roadmap</h2>
                    <p className="crumb-about-card-body">
                        Upcoming ideas include richer collection views, better mobile layouts,
                        additional style themes, and deeper integration with other Crumb tools.
                        The project is intentionally evolving — expect changes, tweaks, and new
                        experiments over time.
                    </p>
                </section>

                <section className="crumb-about-card">
                    <h2 className="crumb-about-card-title">Support The Crumb</h2>
                        <DonationPage/>
                </section>
            </main>
        </div>
    );
}

export default CrumbAboutPage;
